import React from 'react';
import PropTypes from 'prop-types';

import QRCodeInsert from './QRCodeInsert';
import withModal from '../../../../../../../../components/global/modal/withModal';

export const QR_CODE_INSERT_MODAL = 'modal/QR_CODE_INSERT';

const propTypes = {
  actionProps: PropTypes.shape({
    slideshow: PropTypes.shape({
      id: PropTypes.string,
    }),
    includeLogo: PropTypes.bool,
    insertCallout: PropTypes.bool,
    reviewPhotos: PropTypes.bool,
  }),
};
const QRCodeInsertModal = ({ actionProps, ...props }) => {
  return (
    <QRCodeInsert
      slideshow={actionProps?.slideshow}
      includeLogo={actionProps?.includeLogo}
      insertCallout={actionProps?.insertCallout}
      reviewPhotos={actionProps?.reviewPhotos}
      enabled={actionProps?.enabled}
      {...props}
    />
  );
};

QRCodeInsertModal.propTypes = propTypes;

export default withModal(QRCodeInsertModal, {
  name: QR_CODE_INSERT_MODAL,
  size: 'sm',
  type: 'full',
  contentLabel: (
    <p className="w-100 text-center mb-0 h3">Add QR Code to slideshow</p>
  ),
});
